
import React, { useState, useRef, useEffect } from 'react';
import TimePicker from 'react-time-picker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from "moment";
import { GetLocalStorage } from '../../../Helpers/LocalStorage/LocalStorage';
import { UpdateScheduleA } from '../../../Actions/StudentA';
import { useDispatch, useSelector } from "react-redux";
import SuccessStatusChangePopup from "./SuccessPopup";

const RescheduleClassPopup = ({CourseInstructors, setError, rescheduleData, setShowReschedulePopup, EnrollmentId, schedule, setClassStatusChangeSuccessPopup, classStatusChangeSuccessPopup}) => {
  const [classSelectedType, setClassSelectedType] = useState(""); // Driving, Online, InClass
  const [selectedDropdownInstructorId, setSelectedDropdownInstructorId] = useState("");
  const [startTime, setStartTime] = useState('09:00');
  const [endTime, setEndTime] = useState('10:00');
  const [selectedWeeklyScheduleDate, setSelectedWeeklyScheduleDate] = useState(null);
  const [newUpdatedClassEvents, setNewUpdatedClassEvents] = useState([]);

  console.log("rescheduleData in RescheduleClassPopup is:",rescheduleData);
  const Dispatch = useDispatch();

  const handleCancelPopupClick = () =>{
    setShowReschedulePopup(false);
  }

   // Function to handle date selection by the user
   const handleDateChange = (newValue) => {
    setSelectedWeeklyScheduleDate(newValue);
}; 

const handleUpdateAddClassFunction = () => {
    // 1. Validation
    if (!classSelectedType || !selectedDropdownInstructorId) {
      setError("Please select both class type and instructor.");
      setTimeout(() => setError(''), 10000);
      return;
    }
    
    if (!selectedWeeklyScheduleDate || !startTime || !endTime) {
      console.log("Validation failed", { selectedWeeklyScheduleDate, startTime, endTime });
      setError('Please select a date and both start/end time.');
      setTimeout(() => setError(''), 10000); // auto-clear after 5 seconds
      return;
    }
  
    // ✅ Check if selected date is in the future
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Ignore time, just compare date

    const selectedDate = new Date(selectedWeeklyScheduleDate);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate <= today) {
    setError('Please select a date in the future to schedule the class.');
    setTimeout(() => setError(''), 10000);
    return;
    }
  
    const instructorId = selectedDropdownInstructorId; // new

    const matchedInstructor = CourseInstructors.find(
      instructor => instructor?.Instructor?.InstructorId === instructorId
    );
    console.log("matchedInstructor in function is:",matchedInstructor)

    const instructorFullName = matchedInstructor
      ? `${matchedInstructor.FirstName} ${matchedInstructor.LastName}`
      : "";
    console.log("instructorFullName in function is:",instructorFullName)
  
    // 2. Setup baseDate and time parsing
    const baseDate = new Date(new Date(selectedWeeklyScheduleDate).setHours(0, 0, 0, 0));
    const [startHour, startMin] = startTime.split(':');
    const [endHour, endMin] = endTime.split(':');
  
    const startDate = new Date(baseDate);
    startDate.setHours(+startHour, +startMin, 0, 0);
  
    const endDate = new Date(baseDate);
    endDate.setHours(+endHour, +endMin, 0, 0);

    // 3. New Class Object
    const newClass = {
      allDay: false,
      Subject: classSelectedType === 'Driving' ? 'In-Vehicle Class' : `${classSelectedType} Class`,
      StartTime: startDate,
      EndTime: endDate,
      startDate: startDate,
      endDate: endDate,
      start: startDate.toISOString(),
      end: endDate.toISOString(),
      text: '',
      ClassType: classSelectedType,
      Instructors: instructorId,
      event_id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
      ClassNo: schedule.length + 1,
      sourceType: 'addClass',
      InstructorName: instructorFullName,
    };
  
    setNewUpdatedClassEvents(newClass);
    setSelectedWeeklyScheduleDate(null);
    setShowReschedulePopup(false);
    setError("");

    return newClass;

  };

// const SubmitSchedule = () =>
//     SubmitData(newUpdatedClassEvents, Dispatch, EnrollmentId);


  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center"
        style={{
            backgroundColor: "rgba(0, 0, 0, 0.05)", // ⬅️ very light black background
            backdropFilter: "blur(4px)",           // ⬅️ optional blur
            WebkitBackdropFilter: "blur(4px)",     // ⬅️ Safari support
        }}>
        <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[20px] pb-[10px] pt-[5px] shadow-md w-[400px]"> 
            <div className="absolute top-2 right-2">
              <img
                className="absolute right-1 top-[4px] cursor-pointer"
                src={require("../Assets/Cross.svg").default}
                alt=""
                onClick={handleCancelPopupClick}
              />
            </div>
           
          <div className='w-full flex flex-col justify-center gap-[5px] items-center mt-[15px]'>
              {/* <img src={require("../Assets/AddClassPopupPics.svg").default} alt="" /> */}
              <p className='text-[16px] font-semibold'>
                    Reschedule Class
              </p>
              <p className='text-[16px]'>Reschedule a class for the learner.</p>
          </div>

        <div className='w-full flex justify-between py-[10px]'>
                <p className='text-[16px] font-semibold'>{rescheduleData?.classStatus} Class Details</p>
                <p className='text-[16px] w-[150px]'>{rescheduleData?.date} {rescheduleData?.dateNum}, {rescheduleData?.time}</p>
        </div>
          {/* Class Type Dropdown */}
          <div className='relative flex flex-col gap-[5px]'>
            <label className='text-[16px] text-[#333333] font-semibold'>Class Type</label>
            <select
              className='w-full p-[8px] bg-transparent text-[#333] appearance-none border border-[#AEB0FF] rounded'
              style={{
                backgroundColor: 'transparent',   // <-- inline style ensures transparency
                WebkitAppearance: 'none',         // <-- for Safari
                MozAppearance: 'none',            // <-- for Firefox
                appearance: 'none',
              }}
              value={classSelectedType}
              onChange={(e) => setClassSelectedType(e.target.value)}
            >
              <option value="" disabled>Select Class Type</option>
              <option value="Driving">In-Vehicle</option>
              <option value="InClass">In-Class</option>
              <option value="Online">Online</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-2 top-[25px] flex items-center text-[#AEB0FF]">
              ▼
            </div>
          </div>

          {/* Instructor Dropdown */}
          <div className='relative  flex flex-col gap-[5px] mt-[5px]'>
            <label className='text-[16px] text-[#333333] font-semibold'>Instructor</label>
            <select
              className='w-full p-[8px] bg-transparent text-[#333] appearance-none border border-[#AEB0FF] rounded'
              style={{
                backgroundColor: 'transparent',   // <-- inline style ensures transparency
                WebkitAppearance: 'none',         // <-- for Safari
                MozAppearance: 'none',            // <-- for Firefox
                appearance: 'none',
              }}
              value={selectedDropdownInstructorId}
              onChange={(e) => setSelectedDropdownInstructorId(e.target.value)}
            >
              <option value="" disabled>Select Instructor</option>
              {CourseInstructors.map((ins) => (
                <option key={ins?.Instructor?.InstructorId} value={ins?.Instructor?.InstructorId}>
                  {ins.FirstName} {ins.LastName}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-2 top-[25px] flex items-center text-[#AEB0FF]">
              ▼
            </div>
          </div>

          <div className='flex flex-col pt-[10px] gap-[10px]'>
            <div className='flex items-center gap-[35px]'>
                <p className='text-[16px] text-[#333333] font-semibold'>Date</p>
                <div className='w-full'>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                          value={selectedWeeklyScheduleDate}
                          onChange={handleDateChange}
                          renderInput={(params) => 
                            <TextField
                              {...params}
                              variant="outlined"
                              sx={{
                                '& .MuiInputBase-root': {
                                  height: '22px', // Total height of the field
                                  minHeight: '22px',
                                  padding: '0',
                                  fontSize: '10px',
                                },
                                '& .MuiInputBase-input': {
                                  padding: '2px 6px',
                                  height: '100%',
                                  fontSize: '10px',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#AEB0FF',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#AEB0FF',
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#AEB0FF',
                                },
                              }}
                            />}
                      />
                  </LocalizationProvider>
                </div>
            </div>

            <div className=' flex items-center gap-[10px]'>
              <p className='text-[16px] text-[#333333] font-semibold'>From</p>
                <TimePicker
                  onChange={(value) => {
                    if (value) {
                      const [hours, minutesRaw] = value.split(':');
                      const minutes = parseInt(minutesRaw, 10);

                      // Only accept 0 or 30 minutes
                      if (minutes !== 0 && minutes !== 30) {
                        setError("Only 0 or 30 minutes allowed");
                        setStartTime(null); // or keep the previous
                        return;
                      }

                      setError('');
                      setStartTime(value);
                    } else {
                      setStartTime(null);
                    }
                  }}
                  value={startTime}
                  disableClock
                  clearIcon={null}
                  format="h:mm a"
                  className="custom-time-picker"
                />
            </div>

            <div className='flex items-center gap-[30px]'>
              <p className='text-[16px] text-[#333333] font-semibold'>To</p>
                <TimePicker
                  onChange={(value) => {
                    if (value) {
                      const [hours, minutesRaw] = value.split(':');
                      const minutes = parseInt(minutesRaw, 10);

                      if (minutes !== 0 && minutes !== 30) {
                        setError("Only 0 or 30 minutes allowed");
                        setEndTime(null);
                        return;
                      }

                      setError('');
                      setEndTime(value);
                    } else {
                      setEndTime(null);
                    }
                  }}
                  value={endTime}
                  disableClock
                  clearIcon={null}
                  format="h:mm a"
                  className="custom-time-picker"
                />
            </div>

            <div className='mt-[10px] w-full flex flex-col justify-center items-center gap-[10px]'>
                <button
                  type="button"
                  className="rounded-[5px] bg-[#B5AAFF] w-[302px] h-[42px] text-[14px] text-white"
                  onClick={() => {
                    const createdClass = handleUpdateAddClassFunction();
                    if (createdClass) {
                      SubmitData(createdClass, Dispatch, EnrollmentId, setClassStatusChangeSuccessPopup);
                    }
                  }}        
                  >
                  Add Class
                </button>
              
                <button
                  type="button"
                  className=" text-[#B5AAFF] text-[14px]"
                  onClick={handleCancelPopupClick}
                >
                  Cancel
                </button>
            </div>


            {classStatusChangeSuccessPopup && (
              <SuccessStatusChangePopup
                setShowPopup={setClassStatusChangeSuccessPopup}
                heading="Congratulations !!"
                text="Changes saved successfully."
                btnText="Done"
                onClick={() => setClassStatusChangeSuccessPopup(false)} // <-- Add this line
                imageSrc={require("../Assets/SuccessAssets.svg").default} // ✅ Dynamic image source
              />
          )} 
          </div>
        </div>
    </div>
  );
};

export default RescheduleClassPopup;


const SubmitData = (newUpdatedEvents, Dispatch, EnrollmentId, setClassStatusChangeSuccessPopup) => {
  const InsId = GetLocalStorage("UserInfo")?.Institute?.InstituteId;
  console.log("EnrollmentId in the submit data is:", EnrollmentId);
  console.log("newUpdatedEvents in the submit data is:", newUpdatedEvents);

  // 🛠 Wrap in array if it's a single object
  if (!Array.isArray(newUpdatedEvents)) {
    newUpdatedEvents = [newUpdatedEvents];
  }

  newUpdatedEvents = newUpdatedEvents.map((event) => {
    if (!event.EnrollmentFK) {
      event.EnrollmentFK = EnrollmentId;
    }
    return event;
  });

  // Dispatch(UpdateScheduleA({ Events: newUpdatedEvents }));

  // 2. Second: Update schedule separately
  Dispatch(UpdateScheduleA({ Events: newUpdatedEvents }))
  .then((updateResult) => {
    console.log("✅ Schedule updated:", updateResult);
    setClassStatusChangeSuccessPopup(true);
    // window.location.reload(); // reload after second dispatch succeeds
  })
  .catch((error) => {
    console.error("❌ Dispatch error (UpdateScheduleA):", error);
  });
};



// const SubmitData = (
//     newUpdatedEvents,
//     Dispatch,
//     EnrollmentId,
//   ) => {
//     const InsId = GetLocalStorage("UserInfo")?.Institute?.InstituteId;
//     console.log("EnrollmentId in the submit data is:", EnrollmentId);
//     console.log("newUpdatedEvents in the submit data is:", newUpdatedEvents);

//     // Ensure EnrollmentId is correctly assigned
//     newUpdatedEvents = newUpdatedEvents.map((event) => {
//       if (!event.EnrollmentFK) {
//         event.EnrollmentFK = EnrollmentId;
//       }
//       return event;
//     });
//     console.log("newUpdatedEvents in the submit data is:", newUpdatedEvents);
  
//     newUpdatedEvents = newUpdatedEvents.map((value) => {
//       value.EnrollmentFK = EnrollmentId;
//       return value;
//     });
    
//     console.log("Events2", newUpdatedEvents);
  
//     Dispatch(
//       UpdateScheduleA({
//         Events: newUpdatedEvents,
//       })
//     );
//   };
